import React from 'react';
import dayjs from 'dayjs';
import i18n from '../utils/i18n';

const lang = i18n.language;

const utils = {
  shortTimeFormat: () => {
    if (lang === 'ja' || lang === 'cn' || lang === 'tw') {
      return 'YYYY/MM/DD';
    }
    if (lang === 'fr' || lang === 'es') {
      return 'DD/MM/YYYY';
    }
    return 'MM/DD/YYYY';
  },
  shortMonthTimeFormat: () => {
    if (lang === 'ja' || lang === 'cn' || lang === 'tw') {
      return 'YYYY/MM';
    }
    if (lang === 'fr' || lang === 'es') {
      return 'MM/YYYY';
    }
    return 'MM/YYYY';
  },
  longTimeFormat: () => {
    if (lang === 'ja' || lang === 'cn' || lang === 'tw') {
      return 'YYYY/MM/DD HH:mm';
    }
    if (lang === 'fr' || lang === 'es') {
      return 'DD/MM/YYYY HH:mm';
    }
    return 'MM/DD/YYYY HH:mm';
  },
  fullTimeFormat: () => {
    if (lang === 'ja' || lang === 'cn' || lang === 'tw') {
      return 'YYYY/MM/DD HH:mm:ss';
    }
    if (lang === 'fr' || lang === 'es') {
      return 'DD/MM/YYYY HH:mm:ss';
    }
    return 'MM/DD/YYYY HH:mm:ss';
  },
  unixToShortTime: unix =>
    unix && dayjs.unix(unix).format(utils.shortTimeFormat()),
  unixToLongTime: unix =>
    unix && dayjs.unix(unix).format(utils.longTimeFormat()),
  unixToFullTime: unix =>
    unix && dayjs.unix(unix).format(utils.fullTimeFormat()),
  stringToShortTime: string =>
    string && dayjs(string).format(utils.shortTimeFormat()), //2024-01-11T07:57:43Z
  stringToLongTime: string =>
    string && dayjs(string).format(utils.longTimeFormat()),
  unixToShortTimeAfterDays: (unix, day) =>
    unix &&
    dayjs
      .unix((unix + day * 24 * 60 * 60 * 1000) / 1000)
      .format(utils.shortTimeFormat()),
};

export default utils;
